<app-shared-dialog
  [title]="data.title"
  [confirmLabel]="data.buttonLabel"
  [destructive]="!!data.destructiveButton"
  [confirmable]="data.confirmable ?? true"
  [confirmAction]="data.confirmAction"
  [pendingLabel]="data.pendingLabel ?? 'Working...'"
  [failureMessage]="
    data.failureMessage ?? 'Unable to complete this action. Please try again.'
  "
  (confirmError)="data.onConfirmError?.($event)"
>
  {{ data.content }}
</app-shared-dialog>
